import moment from "moment";
import { setCalendarFilters, setCalendarInitialParams, setCalendarScreen } from "../slices/calendar.slice";
import { getClassesCalendar } from "./generic.middleware";
const atualDate = moment();

export const getScheduledClasses =
  (
    {
      activeScreen,
      selectedStart,
      selectedEnd,
      selectedLingoLanguageId,
      selectedType,
      selectedPlanId,
      selectedStatus,
      selectedStudent,
      selectedTeacher,
    },
    sameDay,
  ) =>
  (dispatch) => {
    const isMonthCalendar = activeScreen === "month";
    const isWeekCalendar = activeScreen === "week";
    const isDayCalendar = activeScreen === "day";
    const isListCalendar = activeScreen === "list";
    const monthStart = moment(new Date(selectedStart)).startOf("month");
    const weekStart = moment(new Date(selectedStart)).startOf("week");
    const isSameDay = selectedStart.isSame(atualDate, "day");
    const isSameDayEnd = selectedEnd.isSame(atualDate, "day");
    const monthEnd = moment(new Date(selectedStart)).endOf("month");
    const weekEnd = moment(new Date(selectedStart)).endOf("week");
    const startDate = () => {
      if (isSameDay) {
        return selectedStart;
      }
      if (isMonthCalendar) {
        return monthStart.startOf("week").startOf("day");
      }
      if (isWeekCalendar) {
        return weekStart.startOf("day");
      }
      if (isDayCalendar) {
        return moment(new Date(selectedStart)).startOf("day");
      }
      if (isListCalendar) {
        return moment(new Date(selectedStart)).startOf("day");
      }
    };
    const endDate = () => {
      if (isSameDayEnd) {
        return selectedEnd;
      }
      if (isMonthCalendar) {
        return monthEnd.endOf("week").endOf("day");
      }
      if (isWeekCalendar) {
        return weekEnd.endOf("day");
      }
      if (isDayCalendar) {
        return moment(new Date(selectedEnd)).endOf("day");
      }
      if (isListCalendar) {
        return moment(new Date(selectedEnd)).endOf("day");
      }
    };
    const pageNumber = 1;
    const pageSize = 100;
    const startAt = startDate().format("YYYY-MM-DDTHH:mm:ss.sss");
    const endAt = sameDay ? endDate().format("YYYY-MM-DDTHH:mm:ss.sss") : endDate().format("YYYY-MM-DDTHH:mm:ss.sss");
    const type = selectedType ? selectedType : "";
    const lingoLanguageId = selectedLingoLanguageId ? selectedLingoLanguageId : "";
    const planId = selectedPlanId ? selectedPlanId : "";
    const status = selectedStatus ? selectedStatus : "";
    const student = selectedStudent ? selectedStudent : "";
    const teacher = selectedTeacher ? selectedTeacher : "";
    const orderByAsc = "originalScheduledDateTimeUTC";
    const params = {
      pageNumber,
      pageSize,
      startAt,
      endAt,
      lingoLanguageId,
      type,
      planId,
      status,
      teacher,
      student,
      orderByAsc,
      activeScreen,
    };

    dispatch(getClassesCalendar(params)).catch((err) => {
      console.log("ERROR ON GET SCHEDULED CLASSES: ", err);
    });
  };

export const handleCalendarInitialParams =
  (targetDate = "list", endDate = "", startDate = "", sameDay = false) =>
  (dispatch) => {
    const activeScreen = targetDate;
    const selectedStart = startDate !== "" ? moment(startDate)?.startOf("day") : atualDate.startOf("day");
    const selectedEnd = endDate !== "" ? moment(endDate)?.endOf("day") : atualDate.endOf("day");
    const getSchedulesObj = { activeScreen, selectedStart, selectedEnd };
    dispatch(
      setCalendarInitialParams({
        activeScreen,
        atualDate,
        selectedDateTime: "",
        selectedStart,
        selectedEnd,
        selectedLingoLanguageId: "",
        selectedType: "",
        selectedPlanId: "",
        selectedStatus: "",
        selectedStudent: "",
        selectedTeacher: "",
      }),
    );
    dispatch(getScheduledClasses({ ...getSchedulesObj }, sameDay));
  };

export const handleSetCalendarScreen =
  (activeScreen, endDate = "", startDate = "", sameDay = false) =>
  (dispatch, getState) => {
    const {
      selectedStart,
      selectedEnd,
      selectedLingoLanguageId,
      selectedPlanId,
      selectedType,
      selectedStatus,
      selectedStudent,
      selectedTeacher,
    } = getState().calendarReducer;
    const filters = {
      selectedStart: startDate === "" ? selectedStart : startDate,
      selectedEnd: endDate === "" ? selectedEnd : endDate,
      selectedLingoLanguageId,
      selectedPlanId,
      selectedType,
      selectedStatus,
      selectedStudent,
      selectedTeacher,
    };
    const getSchedulesObj = { activeScreen, ...filters };
    dispatch(setCalendarScreen({ ...filters, activeScreen, selectedDateTime: "" }));
    dispatch(getScheduledClasses(getSchedulesObj, sameDay));
  };

export const applyCalendarFilters =
  ({ startAt, endAt, lingoLanguageId, type, planId, status, student, teacher }, activeScreen, sameDay = false) =>
  (dispatch) => {
    const filters = {
      selectedStart: moment(startAt),
      selectedEnd: moment(endAt),
      selectedLingoLanguageId: Number(lingoLanguageId),
      selectedType: type,
      selectedPlanId: Number(planId),
      selectedStatus: status,
      selectedStudent: student,
      selectedTeacher: teacher,
    };
    const getSchedulesObj = { activeScreen, ...filters };
    dispatch(setCalendarFilters({ ...filters }));
    dispatch(getScheduledClasses({ ...getSchedulesObj, activeScreen }, sameDay));
  };

export const clearCalendarFilters = (targetDate) => (dispatch, getState) => {
  const userData = JSON.parse(sessionStorage.getItem("@lingo"));
  const role = userData ? userData.role : "";
  const isManager = role === "companyManager" || role === "customerService" || role === "coordinator";
  const { activeScreen, atualDate } = getState().calendarReducer;
  const weekStart = atualDate.startOf("week").startOf("day");
  const weekEnd = atualDate.endOf("week").endOf("day");
  const targetWeekStart = targetDate && targetDate.startOf("week").startOf("day");
  const targetWeekEnd = targetDate && targetDate.endOf("week").endOf("day");
  const selectedStart = isManager ? atualDate.startOf("day") : targetDate ? targetWeekStart : weekStart;
  const selectedEnd = isManager ? atualDate.endOf("day") : targetDate ? targetWeekEnd : weekEnd;
  const filters = {
    selectedStart,
    selectedEnd,
    selectedLingoLanguageId: "",
    selectedType: "",
    selectedPlanId: "",
    selectedStatus: "",
    selectedStudent: "",
    selectedTeacher: "",
  };
  const getSchedulesObj = { activeScreen, ...filters };
  dispatch(setCalendarFilters({ ...filters }));
  dispatch(getScheduledClasses(getSchedulesObj));
};

export const setCalendarSchedules = (getSchedulesObj) => (dispatch) => {
  dispatch(getScheduledClasses(getSchedulesObj));
  dispatch(setCalendarFilters({ ...getSchedulesObj }));
};
